module.exports = __webpack_public_path__ + "static/media/django.0a05cde2.png";